/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Selected_LanguagesInputs */



/**
* | output |
* | --- |
* | "Selected Languages" |
*
* @param {Selected_LanguagesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const selected_languages = /** @type {((inputs?: Selected_LanguagesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Selected_LanguagesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Langues sélectionnées")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählte Sprachen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lingue selezionate")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Избранные языки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Idiomas seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选定语言")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択された言語")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित भाषाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Idiomas selecionados")
	return /** @type {LocalizedString} */ ("Selected Languages")
});